import React from "react";
import { Radio } from "@mui/material";

const DSRadio = (props: React.ComponentProps<typeof Radio>) => {
  return <Radio {...props} />;
};

export default DSRadio;
